import { createAppSelector, selectCurrentSectionId } from "./base";

import { RecordingSessionState } from "components/server-types";

export const selectRecordingSessions = createAppSelector(
  [(state) => state.recording_sessions],
  (recording_sessions) => Object.values(recording_sessions),
);

export const selectRecordingSessionsByClassSessionId = createAppSelector(
  [selectRecordingSessions, (state, classSessionId: string) => classSessionId],
  (recordingSessions, classSessionId) =>
    recordingSessions.filter((rs) => rs.class_session_id === classSessionId),
);

export const selectRecordingSessionsForCurrentSection = createAppSelector(
  [selectRecordingSessions, selectCurrentSectionId],
  (recordingSessions, currentSectionId) =>
    recordingSessions.filter((rs) => rs.section_id === currentSectionId),
);

export const selectActiveRecordingSessionForCurrentSection = createAppSelector(
  [selectRecordingSessionsForCurrentSection],
  (recordingSessions) =>
    recordingSessions.find((rs) =>
      [
        RecordingSessionState.PREPARING,
        RecordingSessionState.STARTING,
        RecordingSessionState.STARTED,
      ].includes(rs.state),
    ),
);
